import { BaseService } from "mrb/core";
import { ProducerContentTreeApiRouteService } from "common/services";

class ProducerContentTreeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ProducerContentTreeApiRouteService());
    }

    getContentTree(producerId, abortSignal = null) {
        const url = this.routeService.getContentTree(producerId);
        return this.apiClient.get(url, null, abortSignal);
    }
}

export default ProducerContentTreeService;
